export const LifeAtCampusActions = {
  GET_LIFE_AT_CAMPUS: "GET_LIFE_AT_CAMPUS",
  SET_LIFE_AT_CAMPUS: "SET_LIFE_AT_CAMPUS",
};
